import { useEffect, useState } from 'react';
import { cicloCron, INGESTAO_CRON_MIN } from '@/domain/dashboard';

/** MM:SS a partir de ms. */
function mmss(ms: number): string {
  const s = Math.max(0, Math.round(ms / 1000));
  const m = Math.floor(s / 60);
  return `${String(m).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`;
}

/** "HH:MM:SS · DD/MM" — hora (dado primário) + data curta como contexto. */
function quando(d: Date): string {
  const hora = d.toLocaleTimeString('pt-BR');
  const dia = d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });
  return `${hora} · ${dia}`;
}

/**
 * Rótulo do status consolidado + timer do ciclo de ingestão (GUPM-191 D8):
 * "Status consolidado em <ts>" + barra de progresso do ciclo + contagem regressiva
 * pro próximo disparo do cron (a cada 10 min). Compacto, na largura da coluna do
 * semáforo (dentro do SemaphoreCard). Tica a cada segundo; cleanup do interval no unmount.
 */
export default function CronTimer({
  lastUpdateTs,
  cronMinutes = INGESTAO_CRON_MIN,
}: {
  lastUpdateTs: Date | null;
  cronMinutes?: number;
}) {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  const ciclo = cicloCron(now, cronMinutes);
  return (
    <div className="w-full text-center text-[9px] text-jf-dim">
      <div className="leading-tight">Status consolidado em</div>
      <div className="text-[11px] font-bold tabular-nums text-slate-200">
        {lastUpdateTs ? quando(lastUpdateTs) : '—'}
      </div>
      <div
        className="my-1.5 h-1 overflow-hidden rounded-full bg-jf-border"
        role="progressbar"
        aria-valuenow={ciclo.pct}
      >
        <div
          className="h-full rounded-full bg-jf-yellow transition-[width] duration-1000 ease-linear"
          style={{ width: `${ciclo.pct}%` }}
        />
      </div>
      <div className="leading-tight text-jf-muted" aria-live="polite">
        Próxima em <span className="font-bold tabular-nums text-jf-yellow">{mmss(ciclo.remainingMs)}</span>
      </div>
    </div>
  );
}
